import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { Field, useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import { Icon } from "@mui/material";

import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import {
  QUALIFICATION_OPTIONS,
  formatWorkerName,
} from "../../../../../../Utils/GlobalVariables/Service/Qualification";

const ServiceQualificationModalFormStepOne = ({ editable }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.userSession.user);
  const { values } = useFormState({ subscription: { values: true } });

  const selectedField = QUALIFICATION_OPTIONS.find(
    (option) => values?.[option.field],
  )?.field;
  const locked = editable === false;

  // Opcja jest zablokowana tylko wtedy, gdy zaznaczona jest inna
  const isOptionDisabled = (field) =>
    locked || Boolean(selectedField && selectedField !== field);

  return (
    <div className="ServiceQualificationModalFormStepOne">
      <BMXSeparator
        title={t(
          "global:qualification.customerArrangements",
          "USTALENIA Z KLIENTEM",
        )}
      />
      <Row>
        <Col xs={12}>
          <Field
            name="customerArrangements"
            component={BMXTextField}
            multiline={true}
            readOnly={locked}
            label={t(
              "global:qualification.customerArrangementsLabel",
              "Ustalenia z klientem",
            )}
          />
        </Col>
      </Row>

      <BMXSeparator
        title={t(
          "global:qualification.handlingMethod",
          "SPOSÓB OBSŁUGI ZLECENIA",
        )}
      />
      <Row>
        {QUALIFICATION_OPTIONS.map((option) => (
          <Col xs={12} key={option.field}>
            <Field
              name={option.field}
              fieldtype="checkbox"
              type="checkbox"
              component={BMXTextField}
              readOnly={isOptionDisabled(option.field)}
              label={t(option.label, option.defaultLabel)}
            />
          </Col>
        ))}
      </Row>

      <Row className="mt-4">
        <Col xs={12} className="d-flex align-items-center gap-2">
          <Icon style={{ color: "grey" }}>person</Icon>
          <small style={{ color: "grey" }}>
            {`${t("global:qualification.author", "Technik kwalifikujący")}: ${formatWorkerName(user)}`}
          </small>
        </Col>
      </Row>
    </div>
  );
};

export default ServiceQualificationModalFormStepOne;
